import { render, staticRenderFns } from "./VxCellDropStatus.vue?vue&type=template&id=18a3725f&"
import script from "./VxCellDropStatus.vue?vue&type=script&lang=js&"
export * from "./VxCellDropStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports